import React from 'react';
import Loader from '../../../assets/animations/gif/loader.gif'
import './index.css';

const BILLoader = (props) => {
    
    const { width, height } = props;

    return (
        <div id="bil-loader">
            <img src={Loader} alt={'Bil loader'} style={{width: width ? width : '120px', height: height ? height : '120px'}} />
        </div>
    )
};

export default BILLoader;